import { motion } from 'framer-motion';
import { useLang } from '../../../context/LangContext';
import { AnimatedCounter } from '../../shared/AnimatedCounter';
import { fadeInUp } from '../../../animations/variants';

const stats = [
  { key: "stats.sectors", target: 30, suffix: "+", prefix: "" },
  { key: "stats.availability", target: 500, suffix: "k+", prefix: "" },
  { key: "stats.response", static: "< 2s" },
  { key: "stats.costs", target: 95, suffix: "%", prefix: "" },
];

export const StatsBar = () => {
  const { t } = useLang();

  return (
    <section data-testid="stats-section" className="border-y border-white/[0.05] bg-white/[0.02] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.key}
              className="text-center"
              {...fadeInUp}
              transition={{ delay: i * 0.1, type: "spring", stiffness: 55, damping: 18 }}
            >
              <div className="text-3xl md:text-4xl font-bold text-white mb-2 font-mono">
                {stat.static ? (
                  <span className="text-brand-gold">{stat.static}</span>
                ) : (
                  <span className="text-brand-gold">
                    <AnimatedCounter target={stat.target} suffix={stat.suffix} prefix={stat.prefix} />
                  </span>
                )}
              </div>
              <p className="text-sm text-neutral-500">{t(stat.key)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
